// Mappa Talenti – Full Logic (final version)

/* ── Helpers ───────────────────── */
const dSum = n =>
  Math.abs(n)
    .toString()
    .split("")
    .reduce((s, digit) => s + +digit, 0);
const red22 = n => {
  let sum = Math.abs(n);
  while (sum > 22) {
    sum = dSum(sum);
  }
  return sum === 0 ? 22 : sum;
};
const if0is22 = n => (n === 0 ? 22 : n);

/* ── Spreadsheet Calculator ────── */
function calc(B2, B3, B4, B5) {
  const C = {};

  // ── INPUTS ──
  C.B2 = +B2;   // day (dd)
  C.B3 = +B3;   // month (mm)
  C.B4 = +B4;   // year (yyyy)
  C.B5 = +B5;   // current year

  // ── ROW 4: “Anno ridotto” ──
  C.C4 = red22(C.B4);

  // ── ROWs 7–9: reduce day, keep month, reduce annoRidotto ──
  C.B7 = red22(C.B2);       // giorno ridotto
  C.B8 = C.B3;              // mese (unchanged)
  C.B9 = red22(C.C4);       // anno ridotto

  // ── ROWs 11–12: differences among the top three ──
  const trio = [C.B7, C.B8, C.B9].sort((a, b) => b - a);
  C.B11 = trio[0] - trio[1];
  C.C11 = C.B11 === 0 ? 22 : C.B11;
  C.C12 = trio[2];
  C.D11 = Math.abs(C.C11 - C.C12);
  C.E11 = C.D11 === 0 ? 22 : C.D11;

  // ── ROWs 14–15–17: full sum vs. digit-sum ▷ pick max ──
  C.C14 = C.B2 + C.B3 + C.B4;
  C.D14 = red22(C.C14);
  C.E14 = red22(C.D14);

  C.C15 = dSum(C.B2) + dSum(C.B3) + dSum(C.B4);
  C.E15 = red22(C.C15);

  C.B17 = Math.max(C.E14, C.E15);

  // ── ROWs 20–21: B7 + B8 ──
  C.B20 = C.B7 + C.B8;
  C.C20 = red22(C.B20);
  C.B21 = C.B7 + C.C20;
  C.C21 = red22(C.B21);

  // ── ROWs 26–27: B7 + B9 ──
  C.B26 = C.B7 + C.B9;
  C.C26 = red22(C.B26);
  C.B27 = C.B7 + C.C26;
  C.C27 = red22(C.B27);

  // ── ROWs 32–33: B8 + B9 ──
  C.B32 = C.B8 + C.B9;
  C.C32 = red22(C.B32);
  C.B33 = C.B7 + C.C32;
  C.C33 = red22(C.B33);

  // ── ROWs 38–39: C20 + C32 ──
  C.B38 = C.C20 + C.C32;
  C.C38 = red22(C.B38);
  C.B39 = C.B7 + C.C38;
  C.C39 = red22(C.B39);

  // ── ROW 43: B17 + C38 ──
  C.B43 = C.B17 + C.C38;
  C.C43 = red22(C.B43);

  // ── ROW 22: C22 = RED22(C20 + C43) ──
  C.C22 = red22(C.C20 + C.C43);

  // ── ROW 23: C23 = RED22(C20 + C21 + C22) ──
  C.C23 = red22(C.C20 + C.C21 + C.C22);

  // ── ROW 28: C28 = RED22(C26 + C43) ──
  C.C28 = red22(C.C26 + C.C43);

  // ── ROW 29: C29 = RED22(C26 + C27 + C28) ──
  C.C29 = red22(C.C26 + C.C27 + C.C28);

  // ── ROW 34: C34 = RED22(C32 + C43) ──
  C.C34 = red22(C.C32 + C.C43);

  // ── ROW 35: C35 = RED22(C32 + C33 + C34) ──
  C.C35 = red22(C.C32 + C.C33 + C.C34);

  // ── ROW 40: C40 = RED22(C38 + C43) ──
  C.C40 = red22(C.C38 + C.C43);

  // ── ROW 41: C41 = RED22(C38 + C39 + C40) ──
  C.C41 = red22(C.C38 + C.C39 + C.C40);

  // ── ROW 44: C44 = RED22(C21) ──
  C.C44 = red22(C.C21);

  // ── ROW 45: C45 = RED22(C21 + C23) ──
  C.C45 = red22(C.C21 + C.C23);

  // ── ROW 46: C46 = RED22(E11 + C21) ──
  C.C46 = red22(C.B7 + C.C43);

  // ── ROW 47: C47 = RED22(E11 + C22) ──
  C.C47 = red22(C.B7 + C.B17);

  // ── ROW 48: C48 = RED22(|B17 − E11|) ──
  C.C48 = red22(Math.abs(C.B17 - C.E11));

  // ── ROWs 65–69: “Sfumatore + Sfumature” ──
  C.B65 = C.E11;
  C.C66 = red22(C.B65 + C.B7);
  C.B67 = C.C66;
  C.C67 = red22(C.B65 + C.C43);
  C.B68 = C.C67;
  C.C68 = red22(C.B65 + C.C66 + C.C67);  // ← “SFUMATURA SUPER SEQUENZA” 
  C.B69 = dSum(C.B68);

  // ── ROW 71: C71 = RED22(C20 + C26 + C32 + C38 − E11) ──
  C.B71 = C.C20 + C.C26 + C.C32 + C.C38 - C.E11;
  C.C71 = red22(C.B71);

  // ── ROW 51: C51 = B2 + B3 + B5 ──
  C.C51 = C.B2 + C.B3 + C.B5;
  C.D51 = red22(C.C51);
  C.E51 = red22(C.D51);                   // → “#mrk-small-bottom-green”

  // ── ROW 52: C52 = digit-sum(B2) + digit-sum(B3) + digit-sum(B5) ──
  C.C52 = dSum(C.B2) + dSum(C.B3) + dSum(C.B5);
  C.E52 = red22(C.C52);                   // → “#mrk-small-bottom-blue”

  // ── ROW 54: B54 = MAX(E51, E52) ──
  C.B54 = Math.max(C.E51, C.E52);         // → “#mrk-blue-r5-c2”

  return C;
}

/* ── Map Excel Cells → DOM Selectors ───── */
const cellToSel = {
  'E11': ['#mrk-blue-r1-c1'],
  'B7': ['#mrk-blue-r1-c2'],
  'B8': ['#mrk-blue-r1-c3'],
  'B9': ['#mrk-blue-r1-c4'],
  'C20': ['#mrk-blue-r2-c1'],
  'C21': ['#mrk-small-r2-c2'],
  'C22': ['#mrk-small-r2-c3'],
  'C23': ['#mrk-small-r2-c1'],
  'C26': ['#mrk-blue-r2-c2'],
  'C27': ['#mrk-small-r2-c5'],
  'C28': ['#mrk-small-r2-c6'],
  'C29': ['#mrk-small-r2-c4'],
  'C32': ['#mrk-blue-r2-c3'],
  'C33': ['#mrk-small-r2-c8'],
  'C34': ['#mrk-small-r2-c9'],
  'C35': ['#mrk-small-r2-c7'],
  'C45': ['#mrk-blue-r2_5-c1'],
  'C38': ['#mrk-blue-r3-c2'],
  'C39': ['#mrk-small-r3-c2'],
  'C40': ['#mrk-small-r3-c3'],
  'C41': ['#mrk-small-r3-c1'],
  'C43': ['#mrk-blue-r3-c3'],
  'C44': ['#mrk-blue-r3-c1'],
  'C46': ['#mrk-blue-r4-c1'],
  'C47': ['#mrk-blue-r4-c2'],
  'C48': ['#mrk-blue-r4-c3'],
  'C71': ['#mrk-blue-r4-c4'],
  'B65': ['#mrk-blue-r5-c1'],
  'B67': ['#mrk-small-r5-c2'],
  'B68': ['#mrk-small-r5-c3'],
  'C68': ['#mrk-small-r5-c1'],  // ✅ FINAL SFUMATURA SUPER SEQUENZA
  'B54': ['#mrk-blue-r5-c2'],
  'E51': ['#mrk-small-bottom-green'],
  'E52': ['#mrk-small-bottom-blue'],
  'B17': [
    '#mrk-blue-r1-c5',
    '#mrk-small-top-green',
    '#mrk-small-top-blue'
  ]
};

/* ── Render DOM with latest values ───── */
function render() {
  const dob = $('#dob').val(); // in format YYYY-MM-DD
  if (!dob) {
    Object.values(cellToSel).flat().forEach(sel => $(sel).find('tspan').text(''));
    return;
  }

  const [yyyy, mm, dd] = dob.split('-').map(Number);
  const nowYear = new Date().getFullYear();
  const C = calc(dd, mm, yyyy, nowYear);

  for (const [cell, selList] of Object.entries(cellToSel)) {
    const val = C[cell];
    if (val === undefined) continue;
    selList.forEach(sel => $(sel).find('tspan').length
      ? $(sel).find('tspan').text(val)
      : $(sel).text(val));
  }
  $('.mrk-mappa-svg').show()
}

/* ── Bind ───── */
$('#dob').on('input', render);